import { render, staticRenderFns } from "./Backoffice.vue?vue&type=template&id=1397c473&scoped=true"
import script from "./Backoffice.vue?vue&type=script&lang=js"
export * from "./Backoffice.vue?vue&type=script&lang=js"
import style0 from "./Backoffice.vue?vue&type=style&index=0&id=1397c473&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1397c473",
  null
  
)

export default component.exports